import React, { FunctionComponent } from 'react';
import cx from 'classnames';
import { MediaMobile, MediaMedium } from '../../../MediaWrapper';
import styles from '../style.module.css';

interface TextProps {
  className: string;
}

const TextWrapper: FunctionComponent<TextProps> = ({ children, className }) => {
  const textClassName = cx('abbey fw5', className);
  return <h1 className={textClassName}>{children}</h1>;
};

const mediumTextClass = cx(styles.shopTitle, 'f30 mb16 mb0-ns mb16-l mb16-m mt16-l mt8-ns');

export const ShopTitle: FunctionComponent = ({ children }) => {
  return (
    <>
      <MediaMobile>
        <TextWrapper className="tc f26 mb8 mt12 ph16">{children}</TextWrapper>
      </MediaMobile>
      <MediaMedium>
        <TextWrapper className={mediumTextClass}>{children}</TextWrapper>
      </MediaMedium>
    </>
  );
};
